import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';

const Home = () => {
    const navigate = useNavigate();
    const { config } = useConfig();

    // Bingo habilitado y título desde ConfigContext — sin llamada extra a la API
    const bingoEnabled = !!config?.bingo_config?.enabled;
    const bingoTitle = config?.bingo_config?.title || '🎱 INICIAR EXPERIENCIA BINGO';

    // Default premium menu buttons as shown in Mockup 1, but with completely dynamic styling
    // based on administrative visual identity configurations
    // Botones oficiales de la Página 4 del PDF Cardio Summit 2026:
    // 1. AGENDA (#c20042)
    // 2. PONENTES (#810691)
    // 3. PREGUNTAS AL EXPOSITOR (#c20042)
    // 4. ENCUESTA (#810691)
    const primaryColor = '#c20042';
    const secondaryColor = '#810691';

    const defaultButtons = [
        {
            key: "agenda",
            label: "AGENDA",
            path: "/agenda",
            color: primaryColor
        },
        {
            key: "speakers",
            label: "PONENTES",
            path: "/speakers",
            color: secondaryColor
        },
        {
            key: "questions_private",
            label: "PREGUNTAS AL EXPOSITOR",
            path: "/questions-expert",
            color: primaryColor
        },
        {
            key: "encuesta",
            label: config?.encuesta_config?.title || "ENCUESTA",
            path: "/survey",
            color: secondaryColor
        }
    ];

    // Ocultar botones desactivados por configuración
    const menuButtons = defaultButtons.filter(btn => {
        // Validación específica para Encuesta
        if (btn.key === 'encuesta') {
            if (config?.encuesta_config?.enabled === false) return false;
        }

        // Validación en pageDesigns (activado/desactivado desde Diseños de Páginas)
        const pageDesign = config?.pageDesigns?.[btn.key];
        if (pageDesign && pageDesign.enabled === false) {
            return false;
        }

        // Validación en pages / page_controls (si existe bandera directa en false)
        if (config?.pages?.[btn.key] === false) {
            return false;
        }

        return true;
    });

    const handleButtonClick = (btn) => {
        if (btn.isExternal && btn.url) {
            window.open(btn.url, '_blank', 'noopener,noreferrer');
        } else if (btn.path.startsWith('http')) {
            window.open(btn.path, '_blank', 'noopener,noreferrer');
        } else {
            navigate(btn.path);
        }
    };

    return (
        <div className="flex flex-col items-center justify-start min-h-[60vh] w-full relative z-10 select-none animate-fadeIn">
            {/* Contenedor de botones de navegación (Página 4 PDF) */}
            <div className="w-full max-w-sm px-4 sm:px-6 flex flex-col gap-5 items-center mt-6 mb-8">
                {menuButtons.map((btn, idx) => (
                    <button
                        key={idx}
                        onClick={() => handleButtonClick(btn)}
                        style={{ backgroundColor: btn.color }}
                        className="w-full text-white py-4 px-6 rounded-2xl font-black uppercase tracking-widest text-[15px] sm:text-[17px] shadow-[0_10px_25px_rgba(0,0,0,0.3)] hover:scale-[1.03] active:scale-95 transition-all duration-300 text-center cursor-pointer"
                    >
                        {btn.label}
                    </button>
                ))}

                {/* Botón Bingo (opcional administrativo) */}
                {bingoEnabled && (
                    <button
                        onClick={() => navigate('/bingo')}
                        className="w-full text-white py-4 px-6 rounded-2xl font-black uppercase tracking-widest text-[15px] sm:text-[17px] shadow-[0_10px_30px_rgba(129,6,145,0.4)] hover:scale-[1.03] active:scale-95 transition-all duration-300 text-center relative overflow-hidden"
                        style={{ backgroundColor: secondaryColor }}
                    >
                        <span className="relative z-10 flex items-center justify-center gap-2">
                            {bingoTitle}
                        </span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default Home;
